'use strict';
if (typeof global.Promise !== 'function') {
  global.Promise = require('./lib');
}



//////////////////
// WEBPACK FOOTER
// ./~/lie/polyfill.js
// module id = 156
// module chunks = 0